module.exports = __webpack_public_path__ + "fonts/NouvelR-Extrabold.821d4db2.ttf";